import React, {useRef, useState, useEffect} from "react";
import PropTypes from 'prop-types'
import {CommonFields, DefaultFields, getAdditionalFields} from "./FieldsForProperties";
import {del} from "object-path-immutable";
import Button from "@material-ui/core/Button";
import {Icon, IconButton, Tooltip} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";


const Properties = ({selectedField, selectedPath, setValue, onChangeSelectedProps, nameRef, styles, collapsible}) => {

    const [expanded, setExpanded] = useState(!collapsible);
    const contentRef = useRef(null);
    const [height, setHeight] = useState("auto");

    useEffect(() => {
        if (contentRef.current) {
            setHeight(expanded ? `${contentRef.current.scrollHeight}px` : "0px");
        }
    }, [expanded, selectedField]);

    const onChange = (value, path) => {
        if (selectedField) {
            if (path === 'valueGenerator' && !value) {
                const newField = del(selectedField.field, 'generateWhenEmpty')

                setValue({
                    ...newField,
                    valueGenerator: value,
                }, `properties.${selectedPath}`);

                onChangeSelectedProps({
                    ...newField,
                    valueGenerator: value,
                })
                return
            }

            const isOverridable = Boolean(selectedField.field && selectedField.field.overridable);
            setValue(value, `properties.${selectedPath}`, path, isOverridable);
            onChangeSelectedProps(value, path, isOverridable)
        }
    };

    return (
        <div style={{padding: styles?.padding}}>
            <DefaultFields
                setValue={onChange}
                values={selectedField.field}
                disabled={selectedPath ? selectedField.disabled : true}
                overridable={selectedPath ? selectedField.field.overridable : false}
                nameRef={nameRef}
            />
            <div
                ref={contentRef}
                style={{
                    height,
                    overflow: 'hidden',
                    transition: 'height 0.3s ease'
                }}
            >
                {getAdditionalFields(
                    selectedField.field.type,
                    selectedField.field,
                    onChange,
                    selectedPath ? selectedField.disabled : true,
                    selectedPath ? selectedField.field.overridable : false
                )}
                <CommonFields
                    values={selectedField.field}
                    setValue={onChange}
                    disabled={selectedPath ? selectedField.disabled : true}
                    overridable={selectedPath ? selectedField.field.overridable : false}
                />

            </div>
            <div style={{
                display: collapsible ? "flex" : "none",
                flexDirection: "column",
                alignItems: 'center',
                gap: 10
            }}>
                <div>

                </div>
                <Divider style={{width: '100%'}}/>
                <Tooltip title={'Expand more'}>
                    <IconButton

                        onClick={() => {
                            setExpanded(prev => !prev)
                        }}
                        size="small">
                        <Icon fontSize="small">
                            {expanded ? "expand_less" : "expand_more"}
                        </Icon>
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    )
};
export default Properties

Properties.propTypes = {
    selectedField: PropTypes.object,
    selectedPath: PropTypes.string,
    setValue: PropTypes.func,
    onChangeSelectedProps: PropTypes.func
};
Properties.defaultProps = {
    selectedField: {},
};